import logoUrl from "$assets/logos/elephant-logo-black-240px_51px.png";
import { Image, PNG } from "escpos-buffer";

let logo;
export async function getLogo() {
  if (!logo) {
    logo = await fetch(logoUrl)
      .then((response) => response.arrayBuffer())
      .then(
        (buffer) =>
          new Promise((resolve, reject) => {
            new PNG({ filterType: 4 }).parse(buffer, (error, data) => {
              if (error) {
                reject(error);
                return;
              }
              resolve(data);
            });
          }),
      )
      .then((png) => new Image(png));
  }
  return logo;
}
